import { ComputedRef } from 'vue'

export const ticketKeys = {
  all: ['tickets'] as const,
  event: (eventId: number) => [...ticketKeys.all, 'event', eventId] as const,
  myTickets: (eventId: number) => [...ticketKeys.event(eventId), 'myTickets'] as const,
  userTickets: (eventId: number, userId?: number) => [...ticketKeys.event(eventId), userId] as const,
  frontdesk: (eventId: number) => [...ticketKeys.event(eventId), 'frontdeskTickets'] as const,
  ticketDetails: () => [...ticketKeys.all, 'ticketDetails'] as const,
  ticketById: (ticketId: ComputedRef<number | undefined>) => [...ticketKeys.ticketDetails(), ticketId] as const,
  ticketByQRCode: (qrCode: ComputedRef<string | undefined>) =>
    [...ticketKeys.ticketDetails(), 'qrCode', qrCode] as const,
  receipt: (purchaseId: number) => [...ticketKeys.all, 'receipt', purchaseId] as const,
}
